<!--
    描述： 公共布局页面.vue
    创建时间： 2022-10-18 10:48:57
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
  <div class="app-layout">
    <header class="app-header">
      <div class="container header-container">
        <div class="logo-box">
          <!-- <img src="/static/images/logo.png" alt=""> -->
          <img :src="require('static/images/logo.png')" alt="" class="cursor-pointer" @click="goBusiness">
        </div>

        <div class="tab-container">
          <div class="nav-list">
            <!-- <span class="nav-item" :class="{ 'active-item': curTab === 'home' }" @click="changeTab('home')">首页</span> -->
            <span class="nav-item" :class="{ 'active-item': curTab === 'notice' }"
              @click="changeTab('notice')">资讯公告</span>
            <span class="nav-item" :class="{ 'active-item': curTab === 'help' }" @click="changeTab('help')">帮助中心</span>

            <template v-if="!!token">
              <span class="ml10">已登录</span>
              <span class="login-line"></span>
              <span class="login-item" @click="loginOut">退出</span>
            </template>
            <template v-else>
              <span class="login-item ml10" @click="goLogin">登录</span>
              <span class="login-line"></span>
              <span class="login-item" @click="goRegister">注册</span>
            </template>
          </div>
          <!-- <div class="business-btn" @click="goBusiness">前往业务大厅</div> -->
        </div>
      </div>
    </header>

    <!-- 主体 -->
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </section>

    <!-- footer -->
    <public-footer></public-footer>

    <!-- 修改版底部备案号 -->
    <div class="footer-wrap">
      <div class="container">
        <div class="footer-unit">
          <div>
            <span>© 2025 安徽本末数据科技有限公司 版权所有</span>
          </div>
          <p class="beian-text">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="mr20">{{ beianText }}</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" class="beian-container"><img
                class="beian-img" :src="require('@/assets/images/guohui.png')" alt="备案" /> 皖公网安备 34019102000934号</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      // curTab: 'notice',
      // 友情链接
      linkList: [
        {
          title: '新手入门',
          list: [
            '注册用户',
            '忘记密码',
            '资料下载',
            '常见问题',
            '需求咨询',
          ],
        },
        {
          title: '产品中心',
          list: [
            '服务中心',
            '代理机构',
            '招标采购人',
            '投标供应商',
            '专家人员',
          ],
        },
        {
          title: '法律法规',
          list: ['法律', '法规', '通知', '公告', '隐私'],
        },
        {
          title: '关于我们',
          list: [
            '平台介绍',
            '集团介绍',
            '新闻介绍',
            '联系我们',
            '加入我们',
          ],
        },
      ]
    }
  },
  mounted() {
    // this.curTab= bmStorage.sessionStorage.get('curTab')?bmStorage.sessionStorage.get('curTab'):'home'
  },
  methods: {
    ...mapActions('common', ['updateToken', 'updateTab']),
    // 切换tab 页面
    changeTab(tab) {
      // this.curTab = tab
      this.updateTab(tab)
      this.$router.push({
        path: '/' + tab
      })
    },

    // 前往业务大厅
    goBusiness() {
      const urlParams = bmStorage.localStorage.get('userParams')

      if (!!urlParams) {
        window.open(process.env.VUE_APP_BUSINESS_URL + '?' + urlParams, '_target')
      } else {
        window.open(process.env.VUE_APP_BUSINESS_URL, '_target')
      }
    },

    // 前往登录页面
    goLogin() {
      let from = bmStorage.localStorage.get('from')
      if (from) {
        bmStorage.localStorage.remove('from')
      }
      this.$router.push({
        path: `/login?to=${this.$route.path}`
      })
    },

    // 前往注册页面
    goRegister() {
      let from = bmStorage.localStorage.get('from')
      if (from) {
        bmStorage.localStorage.remove('from')
      }
      this.$router.push({
        path: `/register?to=${this.$route.path}`
      })
    },

    // 点击退出
    loginOut() {
      bmStorage.localStorage.remove('token')
      bmStorage.localStorage.remove('userInfo')
      bmStorage.localStorage.remove('userParams')

      this.updateToken(null)
    },

    // 取地址栏参数
    getUrlParams(url) {
      var search = url.split('?')[1]
      if (!search) {
        return {}
      }
      return JSON.parse(
        '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}'
      )
    },
  },
  computed: {
    ...mapState('common', {
      token: state => state.token,
      curTab: state => state.curTab,
    }),
    // 不同域名的备案号
    beianText() {
      let origin = window.location.origin
      if (origin === 'https://www.anzhaocai.com') {
        return '皖ICP备18011150号-6'
      }

      return '皖ICP备18000629号-4'
    }
  }
}


</script>

<style lang="less" scoped>
@mainColor: #E60012;

.app-layout {
  height: 100%;
  position: relative;
  overflow-y: auto;
  padding-top: 66px;

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .app-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 66px;
    background-color: #fff;
    z-index: 999;
    box-shadow: 0px 0px 20px 0px rgba(174, 174, 174, 0.35);
  }

  // 顶部中心
  .header-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .logo-box {
      height: 40px;
    }

    img {
      width: 130px;
      height: 100%;
    }

    .tab-container {
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 14px;
      color: #333;
    }

    .nav-item {
      // padding: 0 15px;
      cursor: pointer;
      position: relative;
      margin: 0 15px;
      display: inline-block;
      height: 66px;
      line-height: 66px;

      &:hover {
        color: @mainColor;
      }

      &:after {
        content: '';
        height: 2px;
        width: calc(~'100% + 20px');
        position: absolute;
        bottom: 0;
        left: -10px;
        background-color: transparent;
        transition: all .2s;
      }
    }

    .active-item {
      color: @mainColor;

      &:after {
        background-color: @mainColor;
      }
    }

    .login-item {
      cursor: pointer;

      &:hover {
        color: @mainColor;
      }
    }

    .login-line {
      display: inline-block;
      width: 1px;
      height: 13px;
      background-color: #868686;
      margin: 0 5px;
      vertical-align: middle;
    }

    .business-btn {
      margin-left: 25px;
      width: 116px;
      height: 38px;
      line-height: 38px;
      border-radius: 6px;
      border: 1px solid @mainColor;
      color: @mainColor;
      text-align: center;
      cursor: pointer;
      transition: all .5s;

      &:hover {
        background-color: @mainColor;
        color: #fff;
      }
    }
  }

  .app-main {
    height: auto;
    min-height: 100%;
    background-color: #f9f9f9;
	display: flex;
	flex-direction: column;
  }

}

/*** footer ***/
.app-footer {
  padding-top: 30px;
  background-color: #2e2e2e;

  .top {
    display: flex;
    padding-bottom: 20px;
    border-bottom: 1px solid #404040;
  }
}

.left-link {
  display: flex;
  flex: 1;
  margin-right: 65px;
  justify-content: space-between;

  .link-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    color: #fff;
  }

  li {
    font-size: 14px;
    line-height: 32px;
    color: #aeaeae;

    &:hover {
      color: #fff;
    }
  }
}

.right-tel {
  padding-left: 65px;
  border-left: 1px solid #404040;

  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #fff;
  }

  .tel-number {
    color: #FFCC00;
    font-size: 28px;
    line-height: 50px;
    font-weight: bold;
  }

  .office-box {
    display: inline-block;
    width: 104px;
    font-size: 12px;
    color: #fff;
    text-align: center;

    &:last-child {
      margin-left: 30px;
    }
  }
}

.bottom {
  .footer-link {
    width: 100%;
  }

  .link-title {
    color: #fff;
    line-height: 32px;
    margin-top: 8px;
  }

  // .link-title:extend(.home-main-page .left-link .link-title) {
  // }
  li:extend(.left-link li all) {
    float: left;
    margin-right: 25px;
  }

  .footer-unit {
    width: 100%;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #404040;
    color: #fff;
    line-height: 38px;
    margin-top: 18px;
  }

  p {
    color: #999999;

    a {
      color: #999999;
    }

    a:hover {
      color: #fff;
    }
  }

  // p {
  // 	line-height: 24px;

  // 	&:hover {
  // 		color: #fff;
  // 	}
  // }

  .beian-text {
    position: relative;
    padding-left: 25px;
  }

  .beian-img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-60%);
  }
}

/deep/ .footer a {
  color: inherit;
}


.footer-wrap {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  background-color: #2e2e2e;

  .container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .footer-unit {
    width: 100%;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #404040;
    color: #fff;
    line-height: 38px;
    // margin-top: 18px;
  }

  p {
    color: #999999;
  }

  p>a {
    color: #999999;
  }

  p>a:hover {
    color: #fff;
  }

  .beian-text {
    position: relative;
    padding-left: 25px;
  }

  .beian-container {
    position: relative;
    padding-left: 24px;
  }

  .beian-img {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-54%);
    height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/layout/LayoutIndex.vue